import React from "react";

export const Center = ({children}: { children: React.ReactNode }) => {
  return (
    <div className="flex items-start justify-center w-full h-[100%] p-10 pt-20">
      {children}
    </div>
  );
};
